const scrollTop = y => {
  const rootNode = document.getElementById('content');

  rootNode?.scrollTo(0, y);
};

export default scrollTop;
